import React from 'react';
import { navigateTo } from '../services/navigationService';
import '../styles/qolStyles.css';

export default function ScriptWrapper({ children }) {
    const urlPathName = window.location.pathname;

    // if (['/', '/posearch.html', '/petownerlogin.html', '/vetlogin.html', '/emailverify.html'].includes(urlPathName)) {
    //     // do nothing 
    // } else {
    //     // check for session values and redirect to home page if they doesn't exists
    //     const vetId = sessionStorage.getItem('APP_VET_ID');
    //     const ownerId = sessionStorage.getItem('OWNER_ACCOUNT_ID');
    //     if (['/vetdashboard.html', '/podashboard.html'].includes(urlPathName)) {
    //         if (['/vetdashboard.html'].includes(urlPathName)) {
    //             if (!vetId) {
    //                 alert('Session invalid. Please login using Vet Menu!.');
    //                 navigateTo('/');
    //             }
    //         }
    //         if (['/podashboard.html'].includes(urlPathName)) {
    //             if (!ownerId) {
    //                 alert('Session invalid. Please login using Pet Owner Menu!.');
    //                 navigateTo('/');
    //             }
    //         }
    //     }
    //     else {
    //         if (!vetId || !ownerId) {
    //             alert('Session invalid. Please login.');
    //             navigateTo('/');
    //         }
    //     }
    // }


    return (<>{children}</>);
}

